<template>
  <div
    class="child:text-12 child:xl:text-14 child:mb-1.5 container"
    :class="{ 'section-spacing': !isEmbedded }"
    v-html="footnotes"></div>
</template>

<script>
export default {
  props: {
    footnotes: {
      type: [String, Object],
      required: false,
    },
    isEmbedded: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
};
</script>

<style></style>
